import { createBrowserHistory } from 'history';
import { set } from '../../globalState/api';
import { HISTORY_INSTANCE } from './globalState';
export function findBasename(historyBasename, currentPathname, transformBasename) {
  // Iterator.prototype.find() is not supported in legacy browsers
  for (const basename of transformBasenames(historyBasename, transformBasename)) {
    if (currentPathname.startsWith(basename)) {
      return basename;
    }
  }
}
function* transformBasenames(historyBasename, transformBasename = basename => basename) {
  if (Array.isArray(historyBasename)) {
    for (const basename of historyBasename) {
      yield transformBasename(basename);
    }
  } else {
    yield transformBasename(historyBasename);
  }
}
export function initializeHistory(historyBasename, transformBasename) {
  let basename = findBasename(historyBasename, window.location.pathname, transformBasename);
  if (!basename) {
    if (typeof historyBasename === 'string') {
      // Kept for backwards compatibility but should eventually error always
      basename = transformBasename ? transformBasename(historyBasename) : historyBasename;
    }
    if (process.env.NODE_ENV !== 'production') {
      throw new Error('Browser url does not match `historyBasename`');
    }
  }
  const history = createBrowserHistory({
    basename
  });
  set(HISTORY_INSTANCE, history);
  return history;
}